import React from "react";
import ExcelGrid from "components/ExcelGrid";

const money = (value) =>
  Number(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
const number = (digits) => (value) =>
  Number(value).toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });

const COLUMNS = [
  {
    key: "cashFlowDate",
    label: "Date",
    date: true,
    className: "numeric",
  },
  {
    key: "interpolatedYieldPct",
    label: "Interpolated Yield (%)",
    numeric: true,
    className: "text-right numeric",
    headerClassName: "text-right",
    format: number(6),
  },
  {
    key: "yearFraction",
    label: "Year Fraction",
    numeric: true,
    className: "text-right numeric",
    headerClassName: "text-right",
    format: number(8),
  },
  {
    key: "discountFactor",
    label: "Discount Factor",
    numeric: true,
    className: "text-right numeric",
    headerClassName: "text-right",
    format: number(10),
  },
  {
    key: "presentValue",
    label: "Hypothetical Cost ($)",
    numeric: true,
    className: "text-right numeric",
    headerClassName: "text-right",
    format: money,
  },
];

export default function UsTreasuryResults({ result, universeLabel = "Hypothetical" }) {
  if (!result?.rows?.length) {
    return <p className="text-muted italic">No {result?.universeLabel || universeLabel} calculation generated yet.</p>;
  }
  return (
    <div className="space-y-5">
      <p className="text-xs text-muted leading-relaxed">
        {result.methodologyNote}
      </p>
      <ExcelGrid columns={COLUMNS} rows={result.rows} viewportConstrained />
    </div>
  );
}
